import React from "react";
import { Animation } from "../../assets/global/globalStyles";
import {
  Container,
  Content,
  Usuario,
  Status,
  Title,
  Table,
  Tr,
  Td,
} from "./styles";

export default function Notification() {
  return (
    <Animation>
      <Container>
        <Content>
          <Title>Informações do indetificação</Title>
          <Table>
            <thead>
              <Tr>
                <Td>Código da indetificação</Td>
                <Td>3138a600-7641-11eb-bdb0-3f985739e5a9</Td>
              </Tr>
            </thead>
            <tbody>
              <Tr>
                <Td>Código do ativo</Td>
                <Td>Elbert</Td>
              </Tr>
              <Tr>
                <Td>Tipo</Td>
                <Td>teste</Td>
              </Tr>
              <Tr>
                <Td>Endereço</Td>
                <Td>
                  Avenida Engenheiro Fábio Roberto Barnabé Indaiatuba - São
                  Paulo, 13348, Brazil
                </Td>
              </Tr>
              <Tr>
                <Td>Motorista</Td>
                <Td>
                  <Usuario>P</Usuario> Paulo Eduardo
                </Td>
              </Tr>
              <Tr>
                <Td>Observação</Td>
                <Td>testando primeria identificação</Td>
              </Tr>
              <Tr>
                <Td>Data de criação</Td>
                <Td>23/02/2021 23:53:01</Td>
              </Tr>
              <Tr>
                <Td>Status</Td>
                <Td>
                  <Status>Ativo</Status>
                </Td>
              </Tr>
            </tbody>
          </Table>
        </Content>
      </Container>
    </Animation>
  );
}
